import styled from 'styled-components';


export const ActivityListWrapper = styled.div`
    display: flex;
    flex-direction: row-reverse;
    width: 80%;
    margin-top: 2rem;
    padding: 2rem;
    height: calc(100% - 2rem);
    ${({ theme }) => theme.mediaWidth.upToLarge`
        flex-direction: column;
        width: 100%;
    `}
`;

export const ActivityList = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% - 400px);
    flex: 1;
    ${({ theme }) => theme.mediaWidth.upToLarge`
        width: 100%;
    `}
`;

export const ActivitySidebar = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 400px;
    margin-left: 0.5rem;
    ${({ theme }) => theme.mediaWidth.upToLarge`
        width: 100%;
    `}
`;

export const ActivitySummary = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 0.5rem;
    flex-wrap: wrap;
`;

export const ActivitySidebarHeader = styled.div`
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    width: 100%;
`;

export const ActivitySummaryItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    min-width: 160px;
    height: 4rem;
    margin: 0.5rem;
    padding: 0.5rem;
    border-radius: 5px;
    background-color: ${({ theme }) => theme.newBg2};
`;

export const ActivitySummaryItemLabel = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1;
    font-weight: 500;
    font-size: 0.8rem;
    font-style: italic;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const ActivitySummaryItemValue = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    font-size: 1rem;
    font-weight: 500;

    > img {
        width: 1rem;
        height: 1rem;
        margin-left: 0.5rem;
    }
`;

export const ActivityFilter = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    margin-bottom: 0.5rem;
    padding: 0.5rem;
`;

export const ActivityFilterItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    min-width: 150px;
    margin: 0.5rem;
    padding: 0.5rem;
    border-radius: 5px;
    background-color: ${({ theme }) => theme.newBg2};
`;

export const ActivityFilterItemLabel = styled.div`
    width: 100%;
    font-size: 0.8rem;
    font-style: italic;
    font-weight: 500;
    display: flex;
    align-items: flex-start;
`;

export const ActivityFilterItemOption = styled.div`
    width: 100%;
    margin-top: 0.3rem;
    font-size: 0.8rem;
    
    > div {
        border: 1px solid ${({ theme }) => theme.newBg3};
        border-radius: 5px;
        width: 100%;
    }
`;

export const ActivityListLoader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100px;
`

export const ActivityListItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.5rem;
    margin-right: 1rem;
    padding: 1rem;
    border-radius: 0.5rem;
    background-color: ${({ theme }) => theme.newBg2};
`;

export const ActivityListImage = styled.div`
    width: 100px;
    height: 100px;
    margin-right: 0.5rem;
    border-radius: 0.5rem;
    overflow: hidden;
    background-color: ${({ theme }) => theme.newBg3};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    > img {
        //width: 100%;
        //height: 100%;
        max-height: 100%;
        max-width: 100%;
    }

    .CryptoSealImage {
        display: flex;
        position: relative;
        height: 100px;
        width: 100px;
        .crypto-seal-character {
          width: 65px;
          height: 65px;
          position: absolute;
          top: 17px;
          left: 10px;
        }
      }
    
`;

export const ActivityItemInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: calc(100% - 100px);
`;

export const ActivityItemTitle = styled.div`
    font-size: 1.2rem;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0.4rem 0;
    width: 100%;
    cursor: pointer;
`

export const ActivityItemCollection = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 0.8rem;
    font-style: italic;
    margin: 0.2rem 0;

    svg {
        margin-right: 0.3rem;
        fill: rgb(32, 129, 226);
    }
`

export const ActivityItemText = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: calc(100% - 40px);
    font-size: 0.8rem;
    margin: 0.2rem 0;
    text-decoration: none;
    display: flex;
    align-items: center;
`